// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button > div ~ span {\n    /* color: black !important; */\n    font-weight: 400;\n    position: relative;\n}\n.date.hide-underline hr {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
